import { format } from 'date-fns';
import { isDateValid } from '@pb/apps/offers/helpers/validators';

export const getDateFromString = (dateString: string): Date | null => {
    if (!dateString) {
        return null;
    }

    if (!isDateValid(dateString)) {
        return null;
    }

    const dateSplit = dateString.split('/');
    return new Date(dateSplit[2] + '-' + dateSplit[1] + '-' + dateSplit[0]);
};

export const getStringDate = (value?: Date): string | undefined => {
    if (!value) {
        return;
    }
    const date = new Date(value);
    const day = getDoubleDigits(date.getUTCDate());
    const month = getDoubleDigits(date.getUTCMonth() + 1);
    const year = date.getUTCFullYear();

    if (day && month && year) {
        return `${day}/${month}/${year}`;
    }
    return undefined;
};

export const getLongDateTimeString = (value?: Date): string | undefined => {
    if (!value) {
        return;
    }
    const date = new Date(value);
    const day = format(date, 'd');
    const month = format(date, 'LLLL');
    const time = `${format(date, 'HH')}:${format(date, 'mm')}`;

    if (day && month) {
        return `${day} ${month} at ${time}`;
    }
    return undefined;
};

function getDoubleDigits(value: number) {
    if (value.toString().length === 1) {
        return `0${value}`;
    }
    return value;
}
